var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23828 0.238281H13.75V1.75H3.23828V0.238281ZM3.23828 7.76172V6.25H13.75V7.76172H3.23828ZM3.23828 4.73828V3.26172H13.75V4.73828H3.23828ZM0.25 1.75V0.238281H1.76172V1.75H0.25ZM0.25 7.76172V6.25H1.76172V7.76172H0.25ZM0.25 4.73828V3.26172H1.76172V4.73828H0.25Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-filter.d85ed888.svg";
export { ForwardRef as ReactComponent };